import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';

import { ForgetPage } from '../pages/forget/forget';
import { LoginPage } from '../pages/login/login';
import { RegisterPage } from '../pages/register/register';
import { ScorePage } from '../pages/score/score';
import { SettingsPage } from '../pages/settings/settings';
import { ModalContentPage } from '../pages/home/modal';
import { RecordsPage } from '../pages/records/records';

import {AngularFireModule} from 'angularfire2';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import { CoolStorageModule } from 'angular2-cool-storage';
import {configFire} from './firebase';
import { SimpleTimer } from 'ng2-simple-timer';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    ForgetPage,
    LoginPage,
    RecordsPage,
    RegisterPage,
    ScorePage,
    SettingsPage,
    ModalContentPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp,{mode: 'md'}),
    AngularFireModule.initializeApp(configFire),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    CoolStorageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    RegisterPage,
    ScorePage,
    ListPage,
    RecordsPage,
    SettingsPage,
    HomePage,
    ModalContentPage

  ],
  providers: [
    SimpleTimer,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts